<template>
  <div class="wrapper">
  <AppLogo variant="prelogin"/>
  <div class="mb-25">
    <ResetPassword/>
  </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import AppLogo from "../../components/Widgets/AppLogo.vue";
import ResetPassword from "../../components/Authentication/ResetPassword/ResetPassword.vue";

export default defineComponent({
  name: "ResetPasswordPage",
  components: {
    AppLogo,
    ResetPassword,
  },
});
</script>